// Redesenho do wizard (5 steps, ver specs/nexus/plan-wizard-cliente-redesign.md):
// 1 Plano · 2 Variações & Módulos · 3 Matriz & Filiais (novo no Core) ·
// 4 Limites por filial (novo no Core) · 5 Revisão.
// Valores == índice real do mat-step no template (stepper.selectedIndex).
export enum PlanSelectionStep {
    SELECT_PLAN = 0,
    SELECT_MODULES = 1,
    SELECT_BRANCHES = 2,
    BRANCH_LIMITS = 3,
    SUMMARY = 4,
}